import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'

export default {
	name: 'shipment-summary',
	components: {
		BasicSelect,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			locationId:'',
			locationIdErrorMSG:'',
			locationIdError:false,
			locationIdErrorForAlpha:false,
			locationIdErrorForAlphaMSG:'',
			regexForAlphaNumeric:/^[a-zA-Z0-9]{1,30}$/,
			isLoadingSearch:false,
			locationDetails:[],
			showDataTable:false,
			hublist:[]

		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }

    },
		BagCategory: function(isparentbag){
			if (isparentbag==true) {
				return "Parent";
			}else if(isparentbag==false){
				return "Child";
			}
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubid = userdetail[0].HubId[0];
		this.getHubList();

	},
	methods: {
		getHubList() {
			this.hublist = []
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					var HubDetails = result.data.ResponseData
					for (var i = 0; i < HubDetails.length; i++) {
						this.hublist.push({
							"value": HubDetails[i].HubID,
							"text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
						})
					}
				}, error => {
					console.error(error)
				})
		},

		onSubmitSearch: function() {
			var self = this
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
				// this.$alertify.success("your message");
			}).catch(() => {
				console.log('errors exist')
				//this.$alertify.error("your message")
			});
		},
			getLocationDetails() {
				this.locationIdError=false;
				this.locationIdErrorMSG = '';
				this.locationIdErrorForAlpha=false;
				this.locationIdErrorForAlphaMSG='';
			if (this.locationId == '' || this.locationId == undefined) {
				this.locationIdError=true;
				this.locationIdErrorMSG = 'Enter Location Id';
				return false;
			}
			// if(this.regexForAlphaNumeric.test(this.locationId.trim()) == false)
			// {
			// 	this.locationIdErrorForAlpha=true;
			// 	this.locationIdErrorForAlphaMSG="Location Number Must Be AlphaNumeric";
			// 	return false;
			// }
			this.locationDetails=[];

			this.isLoadingSearch = true;
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getLocationReport?locationNumber=' + this.locationId.trim() +'&hubId=' +this.hubid,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						var hubDetails = [];
						var logData = [];
						for (var i = 0; i < this.hublist.length; i++) {
							hubDetails[this.hublist[i].value] = this.hublist[i].text;
						}
						if (result.data.ResponseData.length > 0) {
							result.data.ResponseData.forEach(function(item) {
								item["nextHubName"] = '';
								if (item.nexthub && hubDetails[item.nexthub]) {
									item["nextHubName"] = hubDetails[item.nexthub];
								}
								logData.push(item);
							});
						}
						this.locationDetails = logData;
						console.log(this.locationDetails,"locationDetails");
						this.showDataTable=true;
						this.$alertify.success(result.data.ReturnMessage);
					} else {
						this.showDataTable=false;
						this.showShipmentDetailsTable=false;
						this.showBagdetailsTable=true;
						this.$alertify.error(result.data.ReturnMessage);
						this.locationDetails = [];
					}
				}, error => {
					console.error(error)
				})
		},
		resetForm(){
		 this.locationIdErrorForAlpha=false;
		 this.locationIdErrorForAlphaMSG='';
		 this.isLoadingSearch= false;
		 this.isLoadingSearchBag= false;
		 this.locationIdError=false;
		 this.locationIdErrorMSG = '';
		 this.showDataTable=false;
		 this.locationId='';
		 this.$validator.reset();
		 this.showBinShipmentDetils=false;
	 }
	}
}



// WEBPACK FOOTER //
// ./src/views/components/PalletReportPages/LocationSummary/LocationSummary.js